import { Injectable, inject } from '@angular/core';
import { IListado, ILogIntegracionSoflex, IQueryParam } from 'modelos/src';
import { Observable } from 'rxjs';
import { HelperService } from '../../auxiliares/servicios/helper.service';
import { HttpApiAdminService } from '../../auxiliares/servicios/http-api.service';

@Injectable({
  providedIn: 'root',
})
export class LogIntegracionSoflexService {
  private http = inject(HttpApiAdminService);
  private helper = inject(HelperService);

  public getFiltered(
    queryParams?: IQueryParam,
  ): Observable<IListado<ILogIntegracionSoflex>> {
    const params = this.helper.getQueryParams(queryParams);
    return this.http.get(`/logintegracionsoflex`, { params });
  }

  public getById(id: string): Observable<ILogIntegracionSoflex> {
    return this.http.get(`/logintegracionsoflex/${id}`);
  }
}
